import React from 'react';

import Container from './Container';
import BottomMessage from './BottomMessage';
import TitleIcon from './TitleIcon';
import VerifyButton from './VerifyButton';

export default ({ needs_update, onVerify, isBusy, verification_wait_reason, verification_failure_message }) =>
  ({
    needs_update: (
      <Container>
        {verification_failure_message}
        <VerifyButton onClick={onVerify} isLoading={isBusy}>
          {isBusy ? 'Please wait' : 'Update now'}
        </VerifyButton>
      </Container>
    ),
    manual_microdeposits: (
      <Container>
        <div>We have issued two small transactions (less than $1 each) on your account.</div>
        <div>Once you see them, please come back here and verify your account.</div>
        <BottomMessage>This process can take 2-3 business days.</BottomMessage>
        <VerifyButton onClick={onVerify} isLoading={isBusy}>
          {isBusy ? 'Please wait' : 'Verify account'}
        </VerifyButton>
      </Container>
    ),
    pending_manual_verification: (
      <Container>
        <div>We have issued two small transactions (less than $1 each) on your account.</div>
        <div>Once you see them, please come back here and verify your account.</div>
        <BottomMessage>This process generally takes 1 business day.</BottomMessage>
        <VerifyButton onClick={onVerify} isLoading={isBusy}>
          {isBusy ? 'Please wait' : 'Verify account'}
        </VerifyButton>
      </Container>
    ),
    pending_automatic_verification: (
      <Container>
        <div>We have issued one small transaction (less than $1) on your account.</div>
        <div>We will automatically update you when we complete this verification process.</div>
      </Container>
    ),
    error_plaid: (
      <Container error>
        <TitleIcon name="bell" />
        <div>An error has occured, please contact us. (Code: E201)</div>
        <BottomMessage>You can also try changing to a different account.</BottomMessage>
      </Container>
    ),
  }[verification_wait_reason] ||
  (needs_update ? (
    <Container>
      {verification_failure_message}
      <VerifyButton onClick={onVerify} isLoading={isBusy}>
        {isBusy ? 'Please wait' : 'Update now'}
      </VerifyButton>
    </Container>
  ) : (
    <Container error>
      <TitleIcon name="bell" />
      <div>An error has occured, please contact us. (Code: E202)</div>
      <BottomMessage>You can also try changing to a different account.</BottomMessage>
    </Container>
  )));
